import "./TriviaSurveyCardBody.scss";

import { Alert, Button, Flex, Text } from "@fluentui/react-northstar";
import { SurveyDTO, SurveyResponsesDTO } from "@teams/types/api";
import React from "react";

import { PollyIcon } from "../../../../../_shared/components/PollyIcon";
import { TriviaLeaderboard } from "../../../components/trivia/TriviaLeaderboard";

export const TriviaSurveyCardBody: React.FC<{
  survey: SurveyDTO;
  surveyResponses: SurveyResponsesDTO;
  onViewResults: ((survey: SurveyDTO, responses: SurveyResponsesDTO) => void) | undefined;
}> = ({ survey, surveyResponses, onViewResults }) => {
  if (survey.state === "pending") {
    let text: string;

    if (!survey.deliverAt) {
      if (survey.role === "own") {
        text =
          "Pressing 'Send now' will send a message to all meeting members, and the game will start 60 seconds later";
      } else {
        text = "Waiting for owner to start the game";
      }
    } else {
      text = "Game is starting...";
    }

    return <Alert info content={<Text content={text} weight="bold" align="center" />} />;
  }

  if (survey.state === "open") {
    return (
      <Flex column gap="gap.medium" hAlign="center">
        In progress...
        <Flex className="survey-card-trivia-body__icon-container" hAlign="center" vAlign="center">
          <Text
            className="survey-card-trivia-body__icon"
            style={{ fontSize: "1em" }}
            content={<PollyIcon icon={"lightbulb-icon"} inheritColor />}
          />
        </Flex>
      </Flex>
    );
  }

  return (
    <Flex column gap="gap.medium">
      <TriviaLeaderboard survey={survey} maxDisplay={5} />

      {onViewResults && surveyResponses.canViewResponses && (
        <Button
          secondary
          fluid
          content="Full Results"
          onClick={() => onViewResults(survey, surveyResponses)}
        />
      )}
    </Flex>
  );
};
